export type BuildCurlCommandArgs = {
  method: string;
  url: string;
  headers: Record<string, string>;
  body?: unknown;
};

export const buildCurlCommand = ({ method, url, headers, body }: BuildCurlCommandArgs): string => {
  const upperMethod = method.toUpperCase();
  const lines = Object.entries(headers).map(([name, value]) => `-H '${name}: ${value}'`);
  if (body !== undefined && body !== null) {
    lines.push(`-d '${JSON.stringify(body, null, 2)}'`);
  }
  const firstLine = upperMethod === 'GET' ? `curl ${url}` : `curl -X ${upperMethod} ${url}`;
  // Indent continuation lines (and the body's inner lines) two spaces under the curl.
  return [firstLine, ...lines].join(' \\\n').replaceAll('\n', '\n  ');
};
